import { PasswordRecoveryRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * sendPasswordResetByUserEmail - Function that tries to send a password recovery temporary link  
 * /authenticator/recovery-password  
 * method POST 
 * @async-function
 */
const sendPasswordResetByUserEmail = async (model: PasswordRecoveryRequestType) => {
    const response = await api.post('authenticator/recovery-password', {
        ...model
    });
    return response;
};

export default sendPasswordResetByUserEmail;
